// extracted by mini-css-extract-plugin
export default {"home":"Profile_home__fMaOW","home2":"Profile_home2__cSPhq","main":"Profile_main__roF-E","chang_pass":"Profile_chang_pass__2Umbh"};